import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=47c70f74&scoped=true&"
import script from "./validation.vue?vue&type=script&lang=js&"
export * from "./validation.vue?vue&type=script&lang=js&"
import style0 from "./validation.vue?vue&type=style&index=0&id=47c70f74&lang=scss&scoped=true&"
import style1 from "./validation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c70f74",
  null
  
)

export default component.exports